<div class="step-panel">
  <h3>Revision y envio</h3>
  <p class="step-intro">Revisa el estado general de la postulacion antes del envio y detecta en que secciones aun faltan datos obligatorios.</p>

  <div class="info-banner">
    Usa la opcion <strong>Revisar postulacion</strong> para listar secciones incompletas. Desde ahi puedes volver directo al bloque que necesite ajustes.
  </div>

  <div class="review-actions review-actions-start" *ngIf="!soloLectura">
    <button type="button" class="btn-secondary" (click)="ejecutarRevision()">Revisar postulacion</button>
  </div>

  <div class="review-list">
    <div class="review-item" *ngFor="let seccion of seccionesRevision">
      <div class="review-meta">
        <strong>{{ seccion.label }}</strong>
        <span>{{ seccion.detalle }}</span>
      </div>
      <span class="status-pill" [class.status-ok]="seccion.completa" [class.status-pending]="!seccion.completa">
        {{ seccion.completa ? 'Completa' : 'Pendiente' }}
      </span>
    </div>
  </div>

  <div class="review-errors-box" *ngIf="revisionEjecutada && seccionesPendientes.length > 0">
    <h4>Secciones con informacion pendiente</h4>
    <p>Selecciona una seccion para volver al formulario y completar sus campos obligatorios.</p>

    <div class="review-errors-list">
      <div class="review-error-item" *ngFor="let seccion of seccionesPendientes">
        <div class="review-meta">
          <strong>{{ seccion.label }}</strong>
          <span>{{ seccion.detalle }}</span>
        </div>

        <button type="button" class="btn-outline" *ngIf="puedeEditar" (click)="irASeccion(seccion.key)">
          Completar seccion
        </button>
      </div>
    </div>
  </div>

  <div class="review-summary" *ngIf="!soloLectura; else soloLecturaTpl">
    <strong>Estado actual:</strong>
    <span *ngIf="revisionEjecutada && seccionesPendientes.length === 0; else pendienteTpl">
      la postulacion esta completa. El sistema ya puede habilitar el envio para el postulante.
    </span>
    <ng-template #pendienteTpl>
      la postulacion sigue en preparacion y aun requiere completar informacion antes del envio final.
    </ng-template>
  </div>

  <div class="review-actions" *ngIf="puedeSolicitarEnvio">
    <button type="button" class="btn-primary" (click)="emitirSolicitudEnvio()" [disabled]="!puedeEnviar || enviando">
      {{ enviando ? 'Enviando...' : 'Enviar postulacion' }}
    </button>
  </div>

  <ng-template #soloLecturaTpl>
    <div class="placeholder-box">
      <strong>Solo lectura:</strong> {{ mensaje || 'Este rol puede revisar la informacion, pero no modificar ni enviar la postulacion.' }}
    </div>
  </ng-template>

  <div class="placeholder-box" *ngIf="rol === 'ayudante_postulante'">
    <strong>Importante:</strong>
    <span *ngIf="puedeEditar">
      el ayudante puede revisar errores, volver a la seccion pendiente y completar informacion mientras la postulacion siga editable, pero no puede enviarla.
    </span>
    <span *ngIf="!puedeEditar">
      el ayudante puede revisar errores detectados, pero la postulacion ya no esta disponible para edicion.
    </span>
  </div>
</div>
